module.exports = "tjq = jQuery.noConflict();\r\n"


//////////////////
// WEBPACK FOOTER
// D:/ptrans/front-end-customer/~/raw-loader!D:/ptrans/front-end-customer/~/source-map-loader!D:/ptrans/front-end-customer/src/assets/js/jquery.noconflict.js
// module id = ../../../../raw-loader/index.js!../../../../source-map-loader/index.js!../../../../../src/assets/js/jquery.noconflict.js
// module chunks = 3